"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mkPacmanClient;

var _utils = require("./utils");

var _Visibility = require("../Streams/Visibility");

var _map = require("../Observables/map");

var _fromEvent = require("../Observables/fromEvent");

var _take = require("../Observables/take");

var _DeviceMotion = require("../Streams/DeviceMotion");

var _SumDeviceMotion = require("../Streams/SumDeviceMotion");

var _filter = require("../Observables/filter");

var _mk = require("../Observables/mk");

var _zip = require("../Observables/zip");

var _combineLatestAll = require("../Observables/combineLatestAll");

var _mergeAll = require("../Observables/mergeAll");

var _share = require("../Observables/share");

var _startWith = require("../Observables/startWith");

var _timer = require("../Observables/timer");

var _buffer = require("../Observables/buffer");

var _sampleTime = require("../Observables/sampleTime");

var _mkReplayObservable = require("../Observables/mkReplayObservable");

var _mkPageView = require("./mkPageView");

var _catchError = require("../Observables/catchError");

var _Battery = require("../Streams/Battery");

var _when = require("../Observables/when");

var _EventsDispatcher = _interopRequireDefault(require("../EventsDispatcher"));

var _act = require("../Observables/act");

var _empty = require("../Observables/empty");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var rescue = function rescue(source) {
  return source.pipe((0, _map.map)(function (value) {
    return {
      tag: 'supported',
      value: value
    };
  }), (0, _catchError.catchError)(function (error) {
    return (0, _mk.mk)({
      tag: 'not-supported',
      error: error
    });
  }));
};

var ssrSafe = function ssrSafe(f) {
  return _utils.isSSR ? (0, _empty.empty)() : f();
}; // const fromEventSSRSafe = <T>(element: HTMLElement | Window | Document | any, eventname: string, options?: any) => ssrSafe(() => fromEvent<T>(element, eventname, options))


var MIN_SUM_DEVICE_MOTION = 10;
var $unload = ssrSafe(function () {
  return (0, _fromEvent.fromEvent)(window, "beforeunload");
});
var $battery = ssrSafe(_Battery.mkBattery).pipe(rescue, (0, _take.take)(1), (0, _map.map)(function (t) {
  return t.tag === 'not-supported' ? {
    t: 'battery-not-supported'
  } : {
    t: 'battery',
    a: {
      p: [+t.value.charging, Math.round(t.value.level * 100)]
    }
  };
}));
var $visibilities = ssrSafe(_Visibility.mkVisibilityChange).pipe(rescue, (0, _filter.filter)(function (d) {
  return d.tag === "supported";
}), (0, _map.map)(function (d) {
  return {
    t: d.tag === "supported" ? !d.value ? "hidden" : "visible" : null
  };
}));
var $blur = ssrSafe(function () {
  return (0, _fromEvent.fromEvent)(window, "blur");
}).pipe((0, _map.map)(function (_d) {
  return {
    t: "blur",
    a: {
      e: "window"
    }
  };
}));
var $focus = ssrSafe(function () {
  return (0, _fromEvent.fromEvent)(window, "focus");
}).pipe((0, _map.map)(function (_d) {
  return {
    t: "focus",
    a: {
      e: "window"
    }
  };
}));
var $resize = ssrSafe(function () {
  return (0, _fromEvent.fromEvent)(window, "resize");
}).pipe((0, _map.map)(function (event) {
  return {
    t: event.type,
    a: {
      p: (0, _utils.getViewportSize)()
    }
  };
}));

function mkDocumentEvent(eventName, t) {
  return ssrSafe(function () {
    return (0, _fromEvent.fromEvent)(document, eventName);
  }).pipe((0, _map.map)(function (d) {
    var _d$target;

    return {
      t: t,
      a: {
        e: ((_d$target = d.target) === null || _d$target === void 0 ? void 0 : _d$target.id) || ""
      }
    };
  }));
}

var $focusIn = mkDocumentEvent("focusin", "focus");
var $focusOut = mkDocumentEvent("focusout", "blur");
var $submit = mkDocumentEvent("submit", "submit");
var $fChange = mkDocumentEvent("change", "fchange").pipe((0, _take.take)(1));
var $touchEnd = ssrSafe(function () {
  return (0, _fromEvent.fromEvent)(document, "touchend");
});
var $touchStart = ssrSafe(function () {
  return (0, _fromEvent.fromEvent)(document, "touchstart");
});
var $touchMove = ssrSafe(function () {
  return (0, _fromEvent.fromEvent)(document, "touchmove");
});
var $fTouch = $touchStart.pipe((0, _take.take)(1), (0, _map.map)(function (_d) {
  return {
    t: "ftouch"
  };
}));
var $genericDeviceMotion = ssrSafe(_DeviceMotion.mkGenericDeviceMotion);
var $deviceMotionIncludingGravity = (0, _DeviceMotion.toDeviceMotionIncludingGravity)($genericDeviceMotion);
var $fMotion = (0, _SumDeviceMotion.sumDeviceMotion)($deviceMotionIncludingGravity).pipe((0, _map.map)(function (d) {
  return Math.sqrt(d.x * d.x + d.y * d.y + d.z * d.z) > MIN_SUM_DEVICE_MOTION;
}), (0, _filter.filter)(function (d) {
  return d;
}), (0, _take.take)(1), (0, _map.map)(function (_d) {
  return {
    t: 'fmotion'
  };
}));
var $load = ssrSafe(function () {
  return (0, _fromEvent.fromEvent)(window, "load");
}).pipe((0, _take.take)(1), (0, _map.map)(function (_d) {
  return {
    t: "full_load",
    a: {
      p: (0, _utils.getViewportSize)()
    }
  };
}));

var isDocumentInteractive = function isDocumentInteractive() {
  return document.readyState === "interactive" || document.readyState === "complete";
};

var $domContentLoaded = ssrSafe(function () {
  return isDocumentInteractive() ? (0, _mk.mk)("") : ssrSafe(function () {
    return (0, _fromEvent.fromEvent)(document, "readystatechange");
  }).pipe((0, _map.map)(function (d) {
    return "";
  }));
}).pipe((0, _map.map)(function (_d) {
  return isDocumentInteractive();
}), (0, _filter.filter)(function (d) {
  return d;
}), (0, _take.take)(1), (0, _map.map)(function (_d) {
  return {
    t: "html_load",
    a: {
      p: (0, _utils.getViewportSize)()
    }
  };
}));
var $clicks = (0, _zip.zip)($touchStart)($touchEnd).pipe((0, _share.share)(), (0, _filter.filter)(function (x) {
  return x[1].timeStamp - x[0].timeStamp < 350 && x[0].touches.length === 1 && x[1].touches.length === 0;
}), (0, _map.map)(function (event) {
  var _event$0$touches$0$ta;

  return {
    t: "click",
    a: {
      e: ((_event$0$touches$0$ta = event[0].touches[0].target) === null || _event$0$touches$0$ta === void 0 ? void 0 : _event$0$touches$0$ta.id) || "",
      p: (0, _utils.getEventPos)(event[0].touches[0])
    }
  };
}));
var $touchMotion = (0, _when.when)($touchEnd)((0, _combineLatestAll.combineLatestAll)([$touchStart, $touchMove])).pipe((0, _map.map)(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      s = _ref2[0],
      e = _ref2[1];

  return {
    t: "touchmove",
    a: {
      p: (0, _utils.getTouchMoveDistance)([s.touches[0], e.touches[0]])
    }
  };
}));
var $mousedown = ssrSafe(function () {
  return (0, _fromEvent.fromEvent)(document, "mousedown");
}).pipe((0, _map.map)(function (event) {
  var _event$target;

  return {
    t: "mouseclick",
    a: {
      e: ((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.id) || "",
      p: (0, _utils.getEventPos)(event)
    }
  };
}));
var $scrolls = ssrSafe(function () {
  return (0, _fromEvent.fromEvent)(window, 'scroll');
}).pipe((0, _sampleTime.sampleTime)(500), (0, _map.map)(function (event) {
  return {
    t: event.type,
    a: {
      p: (0, _utils.getDocumentScroll)()
    }
  };
}));

function mkPacmanClient(_ref3) {
  var serverUrl = _ref3.serverUrl,
      rockmanId = _ref3.rockmanId,
      impressionNumber = _ref3.impressionNumber,
      _ref3$signalInterval = _ref3.signalInterval,
      signalInterval = _ref3$signalInterval === void 0 ? 2000 : _ref3$signalInterval,
      logThings = _ref3.logThings;
  var MIN_TOUCH_MOVE_DISTANCE = 50;
  var batch = 0;
  var send = _utils.isSSR ? function () {
    return void 6;
  } : function (data) {
    var payload = JSON.stringify({
      r: rockmanId,
      m: impressionNumber,
      b: batch++,
      d: data
    });

    if (typeof navigator.sendBeacon != 'undefined') {
      navigator.sendBeacon(serverUrl, payload);
    } else {
      var xhr = new XMLHttpRequest();
      xhr.open("POST", serverUrl, true);
      xhr.send(payload);
    }
  };

  var log = function () {
    if (!_utils.isSSR && !!logThings) {
      var pre = document.createElement('pre');
      pre.style.whiteSpace = 'pre';
      pre.style.overflowWrap = 'normal';
      pre.style.width = '100vw';
      pre.style.overflow = 'auto';
      pre.style.margin = '0';
      pre.style.padding = '0';
      pre.style.position = 'fixed';
      pre.style.top = '0';
      pre.style.left = '0';
      document.body.appendChild(pre);
      var arr = [];
      return function (o) {
        console.log(o);
        var txt = typeof o == 'string' ? o : JSON.stringify(o, null, 2);
        arr.unshift(txt);
        pre.innerHTML = arr.slice(0, 100).join("\n");
      };
    } else {
      return function (_txt) {};
    }
  }();

  var flowEventLog = function () {
    if (!_utils.isSSR) {
      return function (o) {
        try {
          console.table(o);
        } catch (err) {
          console.log(o);
        }
      };
    } else {
      return function (_txt) {};
    }
  }();

  if (!_utils.isSSR) {
    send((0, _mkPageView.mkPageView)());
  }

  var $flowEvents = (0, _mkReplayObservable.mkReplayObservable)();
  var $custom = (0, _mkReplayObservable.mkReplayObservable)();
  var $everySecond = (0, _startWith.startWith)(0, (0, _timer.timer)(signalInterval).pipe((0, _map.map)(function (i) {
    return i + 1;
  })));
  var $signal = (0, _mergeAll.mergeAll)([$everySecond, $unload]);
  var $buffer = (0, _buffer.buffer)($signal);
  var events = new _EventsDispatcher["default"]();
  var humanDetected = false;
  (0, _mergeAll.mergeAll)([$load, $domContentLoaded, $resize, $blur, $focus, $focusIn, $focusOut, $visibilities, $clicks, $scrolls, $touchMotion.pipe((0, _act.act)(function (t) {
    var _t$a, _t$a2;

    var deltaX = t === null || t === void 0 ? void 0 : (_t$a = t.a) === null || _t$a === void 0 ? void 0 : _t$a.p[0],
        deltaY = t === null || t === void 0 ? void 0 : (_t$a2 = t.a) === null || _t$a2 === void 0 ? void 0 : _t$a2.p[1];
    events.emit('touchmove', {
      deltaX: deltaX,
      deltaY: deltaY
    });

    if (!humanDetected && Math.sqrt(deltaX * deltaX + deltaY * deltaY) >= MIN_TOUCH_MOVE_DISTANCE) {
      events.emit('manusia', {});
      humanDetected = true;
    }
  })), $mousedown, $battery.pipe((0, _act.act)(function (t) {
    if (t.t === 'battery') {
      var _t$a3, _t$a4;

      var charging = (_t$a3 = t.a) === null || _t$a3 === void 0 ? void 0 : _t$a3.p[0],
          percent = (_t$a4 = t.a) === null || _t$a4 === void 0 ? void 0 : _t$a4.p[1];
      events.emit('battery', {
        charging: charging,
        percent: percent
      });
    }
  })), $fTouch.pipe((0, _act.act)(function (t) {
    events.emit('ftouch', {});
  })), $fChange, $fMotion.pipe((0, _act.act)(function (t) {
    events.emit('fmotion', {});

    if (!humanDetected) {
      events.emit('manusia', {});
      humanDetected = true;
    }
  })), $submit, $flowEvents, $custom, $unload.pipe((0, _map.map)(function (_) {
    return {
      t: 'unload'
    };
  }))].map(function (o) {
    return o.pipe((0, _map.map)(function (v) {
      return _objectSpread(_objectSpread({}, v), {}, {
        s: (0, _utils.getRelativeTime)()
      });
    }));
  })).pipe($buffer).subscribe({
    next: function next(o) {
      log(o);
      send(o);
    },
    error: function error(ex) {
      console.error(ex);
      log(ex.toString());
    },
    complete: function complete() {
      log('completed!');
    }
  });
  var flowEventNumber = 0;

  var sendFlowEvent = function sendFlowEvent(flowEvent) {
    $flowEvents.next({
      t: 'flow_event',
      a: _objectSpread({
        number: flowEventNumber++
      }, flowEvent)
    });

    if (typeof window != "undefined" && !!window.dataLayer && !!window.dataLayer.push) {
      window.dataLayer.push(_objectSpread(_objectSpread({}, flowEvent), {}, {
        event: "gaEvent"
      }));
      flowEventLog(flowEvent);
    }
  };

  var sendCustomEvent = function sendCustomEvent(typeName, eventName) {
    $custom.next({
      t: typeName,
      a: {
        e: eventName
      }
    });
  };

  var sendOptInFlowEvent = function sendOptInFlowEvent(optInFlowName) {
    $custom.next({
      t: "get_sub_method",
      a: {
        e: optInFlowName
      }
    });
  };

  var onAdvanceInFlow = function onAdvanceInFlow(flow, action, args) {
    var gaEvent = {
      category: "Flow",
      action: "advance",
      label: "".concat(action),
      args: args
    };
    sendFlowEvent(gaEvent);
  };

  var onAdvanceInPreFlow = function onAdvanceInPreFlow(label, args) {
    var gaEvent = {
      category: "Pre-Flow",
      action: "advance",
      label: label,
      args: args
    };
    sendFlowEvent(gaEvent);
  };

  var advancedInPreFlow = function advancedInPreFlow(label, args) {
    var gaEvent = {
      category: "Pre-Flow",
      action: "advance",
      label: "".concat(label),
      args: args
    };
    sendFlowEvent(gaEvent);
  };

  var recedeInFlow = function recedeInFlow(flow, reason, args) {
    var gaEvent = {
      category: "Flow",
      action: "recede",
      label: "".concat(reason),
      args: args
    };
    sendFlowEvent(gaEvent);
  };

  var advancedInFlow = function advancedInFlow(flow, action, args) {
    var gaEvent = {
      category: "Flow",
      action: "advance",
      label: "".concat(action),
      args: args
    };
    sendFlowEvent(gaEvent);
  };

  var customEvent = function customEvent(category, action, label, args) {
    var gaEvent = {
      category: category,
      action: action,
      label: label,
      args: args
    };
    sendFlowEvent(gaEvent);
  };

  var predefinedFlowEvents = {
    onAdvanceInPreFlow: onAdvanceInPreFlow,
    onSubmitMSISDN: function onSubmitMSISDN(_ref4) {
      var msisdn = _ref4.msisdn;
      return onAdvanceInFlow('any-flow', 'msisdn-submitted', {
        msisdn: msisdn
      });
    },
    onSubmitPIN: function onSubmitPIN(_ref5) {
      var pin = _ref5.pin,
          msisdn = _ref5.msisdn;
      return onAdvanceInFlow('any-flow', 'pin-submitted', {
        msisdn: msisdn,
        pin: pin
      });
    }
  };
  var trackerFlowEvents = {
    advancedInPreFlow: advancedInPreFlow,
    recedeInFlow: recedeInFlow,
    advancedInFlow: advancedInFlow,
    customEvent: customEvent,
    sendOptInFlowEvent: sendOptInFlowEvent
  };
  return {
    log: log,
    events: events,
    sendFlowEvent: sendFlowEvent,
    sendCustomEvent: sendCustomEvent,
    sendOptInFlowEvent: sendOptInFlowEvent,
    predefinedFlowEvents: predefinedFlowEvents,
    trackerFlowEvents: trackerFlowEvents
  };
}